import { NAVIGATION_PANEL_CLASS } from '../../constants';
import { getMessages } from '../../../../../../store/constants';

export const CREATE_BOARD_ON_SHARED_DRIVE_TIMER = 500;
export const BOARDS_ADD_CREATE_SHARED_DRIVE = getMessages().getText('nav_panel.boards.create_shared_drive');
export const CREATE_ON_SHARED_DRIVE_CLASS = NAVIGATION_PANEL_CLASS + '-shared-drive';
